const CTAButton = (props) => {
  const { text } = props;
  return <button className="product__addToCartBtn">{text}</button>;
};

export default CTAButton;
